import { useEffect } from 'react';
import { useAuth, useOrganizationList } from '@clerk/react';
import { hasDashboardAdminRole } from '../utils/auth';
import DashboardLoadingScreen from './DashboardLoadingScreen';

interface ActivateSoleOrganizationProps {
  children: React.ReactNode;
}

const ActivateSoleOrganization = ({ children }: ActivateSoleOrganizationProps) => {
  const { isLoaded: authLoaded, isSignedIn, orgId, sessionClaims } = useAuth();
  const { isLoaded, setActive, userMemberships } = useOrganizationList({
    userMemberships: {
      infinite: true,
    },
  });
  const isAdmin = hasDashboardAdminRole(sessionClaims);
  const memberships = userMemberships.data ?? [];
  const membershipsKnown = Boolean(isLoaded && userMemberships.data);
  const targetOrgId = !isAdmin && membershipsKnown && memberships.length > 0
    ? memberships[0].organization.id
    : null;
  const membershipsLoading = Boolean(
    isSignedIn && !isAdmin && !orgId && !membershipsKnown
  );

  useEffect(() => {
    if (!authLoaded || !isLoaded || !isSignedIn || isAdmin || orgId || !targetOrgId || !setActive) {
      return;
    }
    void setActive({ organization: targetOrgId });
  }, [authLoaded, isAdmin, isLoaded, isSignedIn, orgId, setActive, targetOrgId]);

  if (!authLoaded || membershipsLoading || (isSignedIn && !isAdmin && !orgId && targetOrgId)) {
    return <DashboardLoadingScreen loadingMessage="Opening your sponsor dashboard..." />;
  }

  return <>{children}</>;
};

export default ActivateSoleOrganization;
